module.exports = __webpack_public_path__ + "img/12.71ee0bd2.png";